import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { Router } from '@angular/router';
var TabsDelegate = /** @class */ (function () {
    function TabsDelegate(router, elementRef) {
        this.router = router;
        if (router) {
            elementRef.nativeElement.useRouter = true;
        }
    }
    TabsDelegate.prototype.onTabbarClick = function (ev) {
        var tabElm = ev.detail;
        if (this.router && tabElm && tabElm.href) {
            this.router.navigateByUrl(tabElm.href);
        }
    };
    TabsDelegate.decorators = [
        { type: Directive, args: [{
                    selector: 'ion-tabs'
                },] },
    ];
    /** @nocollapse */
    TabsDelegate.ctorParameters = function () { return [
        { type: Router, decorators: [{ type: Optional }] },
        { type: ElementRef }
    ]; };
    TabsDelegate.propDecorators = {
        onTabbarClick: [{ type: HostListener, args: ['ionTabbarClick', ['$event'],] }]
    };
    return TabsDelegate;
}());
export { TabsDelegate };
